// extracted by mini-css-extract-plugin
export var borderRadius = "_au-4";
export var large = "_au-3";
export var logoContainer = "_au-0";
export var nameLogo = "_au-2";
export var small = "_au-1";